var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6712_11738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0615 0.179734C26.4342 0.550079 25.3859 1.59755 24.1395 3.12038L25.2841 5.27888C26.0902 4.13192 26.9047 3.09827 27.7191 2.22216C27.7851 2.15306 27.8154 2.1199 27.8154 2.1199C27.7851 2.15306 27.7493 2.18899 27.7191 2.22216C27.4522 2.51512 26.6433 3.45756 25.4217 5.3231C26.5965 5.26507 28.3904 5.02462 29.8734 4.77588C30.3137 2.32165 29.4442 1.21062 29.4442 1.21062C29.4442 1.21062 28.3409 -0.572011 27.056 0.190789L27.0615 0.182498V0.179734Z",
    fill: "url(#paint0_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2095 18.3014C23.0637 18.3263 22.9151 18.3539 22.7583 18.3788C22.8381 18.3678 22.9124 18.3567 22.9894 18.3429C23.061 18.3263 23.1352 18.3125 23.2095 18.2959V18.3014Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2095 18.3014C23.0637 18.3263 22.9151 18.3539 22.7583 18.3788C22.8381 18.3678 22.9124 18.3567 22.9894 18.3429C23.061 18.3263 23.1352 18.3125 23.2095 18.2959V18.3014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 16.4278C23.6277 16.4278 23.6552 16.4195 23.6772 16.4168C23.7735 16.403 23.8698 16.3864 23.9634 16.3643C23.8478 16.3864 23.7323 16.4057 23.6085 16.4278H23.6057Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 16.4278C23.6277 16.4278 23.6552 16.4195 23.6772 16.4168C23.7735 16.403 23.8698 16.3864 23.9634 16.3643C23.8478 16.3864 23.7323 16.4057 23.6085 16.4278H23.6057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9109 10.8481C22.2575 10.1986 22.6125 9.56294 22.9674 8.94662C23.3361 8.30266 23.713 7.68358 24.09 7.08107C24.112 7.04515 24.1368 7.00922 24.156 6.97329C24.5302 6.38184 24.9072 5.81251 25.2868 5.27081L24.1423 3.1123C24.057 3.21733 23.9717 3.32235 23.8836 3.4329C23.5507 3.8447 23.2123 4.28414 22.8574 4.75398C22.4611 5.28186 22.0539 5.84567 21.6385 6.43988C21.2588 6.98711 20.8681 7.55921 20.4801 8.15342C20.1472 8.65919 19.8198 9.17601 19.4896 9.70942C19.4786 9.72876 19.4676 9.74811 19.4539 9.77022L20.9451 12.7109C21.2615 12.0752 21.5862 11.4506 21.9109 10.8453V10.8481Z",
    fill: "url(#paint1_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1176 27.4C14.9195 27.939 14.7214 28.4917 14.5233 29.0555C14.5233 29.0638 14.5178 29.0721 14.5151 29.0776C14.4875 29.155 14.4573 29.2379 14.4325 29.3153C14.2977 29.694 14.1821 30.0367 13.9153 30.8133C14.3527 31.0123 14.7049 31.5402 15.0406 32.1371C15.0048 31.518 14.7517 30.9377 14.2619 30.4899C16.4245 30.5867 18.2982 30.0422 19.2475 28.4613C19.3328 28.3204 19.4126 28.1739 19.4841 28.0136C19.0466 28.5691 18.5019 28.804 17.4783 28.746C17.4783 28.746 17.4728 28.746 17.4701 28.746C17.4701 28.746 17.4756 28.746 17.4783 28.746C18.9861 28.0716 19.74 27.4277 20.4003 26.3609C20.5572 26.1066 20.714 25.8302 20.8708 25.5234C19.5529 26.8722 18.0424 27.2563 16.419 26.9661L15.2139 27.0988C15.1754 27.201 15.1396 27.3005 15.1011 27.4028L15.1231 27.3973L15.1176 27.4Z",
    fill: "url(#paint2_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6954 24.7134C15.9541 24.0418 16.2237 23.3619 16.4988 22.6765C16.763 22.0187 17.0326 21.3582 17.3105 20.6949C17.5884 20.0316 17.8718 19.3627 18.1607 18.6967C18.4523 18.0195 18.755 17.3424 19.0631 16.6681C19.3658 16.002 19.674 15.3387 19.9849 14.6864C20.0949 14.4515 20.2132 14.2138 20.326 13.9817C20.5241 13.5754 20.7222 13.1747 20.9231 12.7767C20.9341 12.7546 20.9451 12.7325 20.9561 12.7131L19.4649 9.77246C19.4428 9.81115 19.4153 9.85261 19.3906 9.8913C19.0439 10.4579 18.6972 11.0383 18.3588 11.6269C18.0149 12.2239 17.6792 12.832 17.349 13.451C17.0739 13.9706 16.8015 14.4957 16.5346 15.0264C16.4823 15.1342 16.43 15.242 16.3778 15.347C16.0531 16.0158 15.7615 16.657 15.4946 17.2789C15.1919 17.9808 14.9278 18.6524 14.6994 19.2881C14.5453 19.7082 14.4105 20.1089 14.2812 20.4986C14.1766 20.8303 14.0803 21.1619 13.9813 21.4936C13.7584 22.2702 13.5658 23.0496 13.409 23.8317L14.9085 26.7945C15.1066 26.2666 15.3102 25.7305 15.5193 25.1888C15.5826 25.034 15.6376 24.882 15.6982 24.7327V24.7106L15.6954 24.7134Z",
    fill: "url(#paint3_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.376 23.926C13.1889 24.8712 13.0541 25.8109 12.9853 26.7506L12.977 26.8473C12.5093 26.0983 11.2574 25.3714 11.2602 25.377C12.1571 26.6732 12.8367 27.9694 12.9358 29.2186C12.457 29.3153 11.7994 29.1744 11.04 28.898C11.8297 29.6249 12.424 29.8239 12.6579 29.8792C11.9288 29.9261 11.1749 30.4236 10.41 30.9985C11.5243 30.5452 12.4268 30.3656 13.0761 30.5093C12.0498 33.403 11.0263 36.5979 9.99176 40.0001C10.3082 39.9061 10.4953 39.6933 10.5998 39.4086C10.7842 38.7951 11.9948 34.7572 13.8933 29.4784C13.9483 29.3292 14.0033 29.1744 14.0583 29.0251C14.0721 28.9809 14.0886 28.9395 14.1051 28.9008C14.3032 28.3453 14.5151 27.7787 14.7297 27.1983C14.7792 27.0656 14.826 26.9357 14.8783 26.8031C14.8783 26.8031 14.8783 26.7976 14.8783 26.7948L13.3787 23.832C13.3732 23.8624 13.3677 23.8956 13.3595 23.9315L13.3677 23.9232L13.376 23.926Z",
    fill: "url(#paint4_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1707 12.9562C21.1267 13.0446 21.0854 13.1331 21.0414 13.2188C20.9121 13.4841 20.7828 13.7549 20.648 14.0341C20.5049 14.3353 20.3591 14.6393 20.2132 14.9544C20.139 15.1119 20.0647 15.2722 19.9904 15.4325C19.7675 15.9162 19.5419 16.4164 19.3135 16.9333C19.0329 17.5662 18.744 18.2239 18.4523 18.9094C18.1772 19.5616 17.8911 20.236 17.6077 20.9352C17.3353 21.5985 17.0629 22.2812 16.785 22.9859C16.5374 23.6133 16.287 24.26 16.0366 24.9261C16.0256 24.9565 16.0146 24.9896 16.0008 25.02C15.7505 25.6806 15.4973 26.3577 15.2442 27.0514C15.2387 27.068 15.2332 27.0818 15.2277 27.1012L16.4328 26.9685C16.4108 26.963 16.3833 26.9602 16.3613 26.9574C17.8003 26.7806 19.7235 25.7027 20.9534 24.365C21.5229 23.7542 22.0402 23.0329 22.5189 22.1872C22.8739 21.5598 23.2095 20.8606 23.5314 20.0895C23.8093 19.4151 24.0762 18.6855 24.3349 17.8951C24.0019 18.0692 23.625 18.1991 23.2068 18.2875C23.1325 18.3041 23.0582 18.3179 22.9812 18.3317C22.9041 18.3455 22.8271 18.3566 22.75 18.3677C24.0955 17.8508 24.9429 16.8559 25.5565 15.6371C25.2043 15.8775 24.6293 16.1926 23.9387 16.3418C23.8451 16.3639 23.7516 16.3777 23.6525 16.3943C23.6305 16.3943 23.603 16.4026 23.581 16.4054H23.5865C24.0542 16.2119 24.4477 15.9908 24.7888 15.7338C24.8631 15.6785 24.9347 15.6232 25.0007 15.5624C25.1053 15.4712 25.2016 15.3773 25.3006 15.2805C25.3611 15.217 25.4189 15.1506 25.4767 15.0843C25.6115 14.924 25.7353 14.7527 25.8536 14.5675C25.8894 14.5094 25.9252 14.4542 25.9582 14.3934C26.005 14.3077 26.0462 14.222 26.0875 14.1419C26.2746 13.766 26.4259 13.4288 26.5442 13.1358C26.6048 12.9866 26.6543 12.8539 26.7011 12.724C26.7203 12.6743 26.7368 12.6245 26.7533 12.5748C26.8029 12.4339 26.8386 12.3095 26.8689 12.1962C26.9157 12.0303 26.9432 11.8977 26.957 11.8037C26.9102 11.8396 26.8607 11.8756 26.8001 11.9115C26.3929 12.1547 25.6996 12.373 25.1383 12.4753C25.1383 12.4753 25.1218 12.4753 25.1135 12.4808C25.0557 12.4891 25.0035 12.5002 24.9429 12.5057L24.9704 12.4919L21.19 12.9065C21.19 12.9065 21.1817 12.9313 21.1762 12.9451L21.1707 12.9562Z",
    fill: "url(#paint5_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4382 5.31757C25.1025 5.83439 24.7366 6.42031 24.3376 7.08361C24.3156 7.11678 24.2936 7.15547 24.2743 7.18864C23.9331 7.7635 23.5727 8.39364 23.1875 9.08458C22.8573 9.68156 22.5162 10.32 22.1585 11.0082C21.8476 11.6079 21.5284 12.2436 21.1955 12.9179L24.9759 12.5034C26.0792 11.9976 26.5718 11.5416 27.0505 10.8755C27.1771 10.6931 27.3064 10.5024 27.4302 10.3034C27.8209 9.69814 28.2006 9.02931 28.5418 8.366C28.8719 7.72481 29.1608 7.09191 29.3837 6.51704C29.524 6.15499 29.6396 5.81505 29.7166 5.51656C29.7854 5.254 29.8404 5.00526 29.8817 4.76758C28.4124 5.01908 26.6103 5.25953 25.4299 5.31757H25.4409H25.4382Z",
    fill: "url(#paint6_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9784 18.3486C22.9014 18.3625 22.8243 18.3735 22.7473 18.3846C22.8271 18.3763 22.9041 18.3625 22.9784 18.3486Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9784 18.3486C22.9014 18.3625 22.8243 18.3735 22.7473 18.3846C22.8271 18.3763 22.9041 18.3625 22.9784 18.3486Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9784 18.3486C22.9014 18.3625 22.8243 18.3735 22.7473 18.3846C22.8271 18.3763 22.9041 18.3625 22.9784 18.3486Z",
    fill: "url(#paint7_linear_6712_11738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 16.428C23.6277 16.428 23.6552 16.4198 23.6772 16.417C23.6552 16.417 23.6305 16.4253 23.6057 16.428Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 16.428C23.6277 16.428 23.6552 16.4198 23.6772 16.417C23.6552 16.417 23.6305 16.4253 23.6057 16.428Z",
    fill: "#BD202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6057 16.428C23.6277 16.428 23.6552 16.4198 23.6772 16.417C23.6552 16.417 23.6305 16.4253 23.6057 16.428Z",
    fill: "url(#paint8_linear_6712_11738)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6712_11738",
    x1: 27.8177,
    y1: 15.9039,
    x2: 36.5352,
    y2: 13.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F69822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6712_11738",
    x1: 8.61021,
    y1: 55.1898,
    x2: 26.5423,
    y2: 17.0973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6712_11738",
    x1: 14.5441,
    y1: 52.3516,
    x2: 25.2251,
    y2: 29.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#662E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CC2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6712_11738",
    x1: 9.25891,
    y1: 52.885,
    x2: 27.191,
    y2: 14.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6712_11738",
    x1: 11.0573,
    y1: 50.3256,
    x2: 20.4785,
    y2: 30.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#662E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CC2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6712_11738",
    x1: 13.169,
    y1: 54.7256,
    x2: 31.1011,
    y2: 16.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6712_11738",
    x1: 11.8786,
    y1: 57.0029,
    x2: 29.8107,
    y2: 18.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6712_11738",
    x1: 14.3397,
    y1: 55.2762,
    x2: 32.2712,
    y2: 17.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6712_11738",
    x1: 14.2296,
    y1: 55.2226,
    x2: 32.1597,
    y2: 17.1319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6712_11738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 40,
    fill: "white",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/LAMP.4f0c5cf81bc56bbbec657906b04f6344.svg";
export { ForwardRef as ReactComponent };